import { render, staticRenderFns } from "./Candidate.vue?vue&type=template&id=33d3cb7c"
import script from "./Candidate.vue?vue&type=script&lang=js"
export * from "./Candidate.vue?vue&type=script&lang=js"
import style0 from "./Candidate.vue?vue&type=style&index=0&id=33d3cb7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports